"use client";

// The hero CTAs are a client island: buttonVariants() lives on the client, and the secondary CTA
// smooth-scrolls to an in-page anchor. Kept out of LocationHero so that stays a Server Component.

import { buttonVariants } from "@/components/ui";
import { cn, scrollToId } from "@/lib/utils";

interface HeroCta {
  label: string;
  href: string;
}

interface Props {
  primary: HeroCta;
  secondary?: HeroCta;
}

export default function HeroCtas({ primary, secondary }: Props) {
  const onAnchorClick = (href: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith("#")) {
      event.preventDefault();
      scrollToId(href.slice(1));
    }
  };

  return (
    <div className="mt-7 flex flex-wrap items-center gap-3">
      <span className="cta-glow-btn-wrap">
        <a href={primary.href} className="cta-glow-btn-inner">
          {primary.label}
        </a>
      </span>
      {secondary && (
        <a
          href={secondary.href}
          onClick={onAnchorClick(secondary.href)}
          className={cn(buttonVariants({ variant: "outline", size: "lg" }), "px-6 font-semibold")}
        >
          {secondary.label}
        </a>
      )}
    </div>
  );
}
